import { injectStyle } from "../core/style";
import { attr, csv, escapeHtml, intAttr } from "../core/dom";
import { icon } from "../core/icons";

// iOS (Apple HIG): component styles, assembled into the global runtime
// stylesheet by core/style.ts. References design tokens via var(--rp-*).
export const iosStyle = `
/* --- iOS (Apple HIG) — flat document approximations, no device chrome --- */
ios-navbar, ios-navbar { display:block; width:100%; max-width:100%; background:var(--rp-a-ios-bar-94); border-bottom:1px solid var(--rp-c-ios-gray-4); font-family:-apple-system,BlinkMacSystemFont,sans-serif; }
.rp-ios-statusbar { display:flex; align-items:center; justify-content:space-between; height:22px; padding:2px 20px 0; font-size:13px; font-weight:600; color:var(--rp-c-black); letter-spacing:-.01em; }
.rp-ios-statusbar-right { display:flex; align-items:center; gap:5px; }
.rp-ios-statusbar-right svg { display:block; }
.ios-navbar-row { display:grid; grid-template-columns:1fr auto 1fr; align-items:center; min-height:40px; padding:2px 8px; }
.rp-ios-nav-leading { display:flex; align-items:center; gap:1px; color:var(--rp-c-ios-blue); font-size:16px; }
.rp-ios-nav-leading svg { margin-right:-2px; }
.rp-ios-nav-title { text-align:center; font-weight:600; font-size:16px; color:var(--rp-c-black); white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.rp-ios-nav-trailing { display:flex; align-items:center; justify-content:flex-end; gap:14px; color:var(--rp-c-ios-blue); font-size:16px; }
.rp-ios-nav-large { font-size:32px; font-weight:700; color:var(--rp-c-black); letter-spacing:-.02em; padding:0 16px 8px; }
ios-tabbar, ios-tabbar { display:flex; width:100%; max-width:100%; background:var(--rp-a-ios-bar-94); border-top:1px solid var(--rp-c-ios-gray-4); padding:8px 0 22px; }
.rp-ios-tab { flex:1; display:flex; flex-direction:column; align-items:center; gap:3px; color:var(--rp-c-ios-gray); font-size:10px; }
.rp-ios-tab.active { color:var(--rp-c-ios-blue); }
.rp-ios-tab-label { font-size:10px; font-weight:500; letter-spacing:-.01em; }
ios-list, ios-list { display:flex; flex-direction:column; background:transparent; width:100%; max-width:100%; font-family:-apple-system,sans-serif; }
.rp-ios-list-card { display:flex; flex-direction:column; background:var(--rp-surface); border-radius:10px; overflow:hidden; }
.ios-list-header { padding:0 16px 7px; font-size:13px; color:var(--rp-c-ios-gray-label); background:transparent; text-transform:uppercase; letter-spacing:.02em; }
.ios-list-footer { padding:7px 16px 0; font-size:13px; line-height:1.35; color:var(--rp-c-ios-gray); background:transparent; }
ios-list-item, ios-list-item { position:relative; display:flex; align-items:center; gap:12px; min-height:44px; padding:8px 16px; font-size:16px; color:var(--rp-c-black); background:var(--rp-surface); }
ios-list-item::after { content:""; position:absolute; left:16px; right:0; bottom:0; height:1px; background:rgba(60,60,67,.29); transform:scaleY(.5); transform-origin:bottom; }
ios-list-item:has(.rp-ios-li-icon)::after { left:52px; }
ios-list-item:last-child::after, ios-list-item:only-child::after { display:none; }
.rp-ios-li-icon { flex:0 0 auto; display:grid; place-items:center; width:29px; height:29px; border-radius:7px; background:var(--rp-c-ios-blue); color:var(--rp-c-white); }
.rp-ios-li-body { flex:1; min-width:0; display:flex; flex-direction:column; gap:1px; }
.rp-ios-li-label { overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
.rp-ios-li-sub { font-size:13px; color:var(--rp-c-ios-gray); overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
.rp-ios-li-trailing { flex:0 0 auto; display:flex; align-items:center; gap:6px; color:var(--rp-c-ios-gray); }
.rp-ios-li-detail { color:var(--rp-c-ios-gray); font-size:16px; }
.rp-ios-li-chevron { display:flex; color:var(--rp-c-ios-gray-3); margin-right:-4px; }
ios-list-item[align="center"] .rp-ios-li-body, ios-list-item[align="center"] .rp-ios-li-label { text-align:center; }
ios-list-item[align="center"] { justify-content:center; }
ios-list-item[role-variant="destructive"] .rp-ios-li-label { color:var(--rp-c-ios-red); }
ios-list-item[role-variant="action"] .rp-ios-li-label { color:var(--rp-c-ios-blue); }
ios-action-sheet, ios-action-sheet { display:flex; flex-direction:column; gap:8px; width:100%; max-width:100%; min-width:0; padding:8px; font-family:-apple-system,sans-serif; }
.rp-ios-as-group { border-radius:var(--rp-radius-lg); overflow:hidden; background:var(--rp-a-white-82); backdrop-filter:blur(20px); }
.rp-ios-as-title { padding:14px; text-align:center; font-size:13px; color:var(--rp-c-ios-gray); border-bottom:1px solid var(--rp-c-mac-border); }
.rp-ios-as-action { padding:16px; text-align:center; font-size:18px; color:var(--rp-c-ios-blue); border-bottom:1px solid var(--rp-c-mac-border); }
.rp-ios-as-action:last-child { border-bottom:0; }
.rp-ios-as-action.destructive { color:var(--rp-c-ios-red); }
.rp-ios-as-action.cancel { font-weight:600; }
ios-alert, ios-alert { display:block; width:270px; border-radius:var(--rp-radius-lg); overflow:hidden; background:var(--rp-a-white-92); backdrop-filter:blur(20px); font-family:-apple-system,sans-serif; }
.ios-alert-body { padding:18px 16px 14px; text-align:center; }
.ios-alert-title { font-size:17px; font-weight:600; color:var(--rp-c-black); }
.ios-alert-msg { margin-top:3px; font-size:13px; color:var(--rp-c-black); }
.ios-alert-actions { display:flex; border-top:1px solid var(--rp-c-mac-border); }
.ios-alert-btn { flex:1; padding:11px; text-align:center; font-size:17px; color:var(--rp-c-ios-blue); }
.ios-alert-btn.primary { font-weight:600; }
.ios-alert-btn:not(:last-child) { border-right:1px solid var(--rp-c-mac-border); }
ios-switch, ios-switch { display:inline-flex; align-items:center; gap:8px; font-family:-apple-system,sans-serif; font-size:16px; flex:0 0 auto; }
.ios-switch-track { position:relative; width:51px; height:31px; border-radius:999px; background:var(--rp-c-ios-green); transition:background .2s; flex:0 0 auto; }
.ios-switch-dot { position:absolute; top:2px; left:22px; width:27px; height:27px; border-radius:50%; background:#fff; box-shadow:0 3px 8px rgba(0,0,0,.15), 0 1px 1px rgba(0,0,0,.16); }
ios-switch[off] .ios-switch-track, ios-switch[state="off"] .ios-switch-track { background:var(--rp-c-ios-gray-3); }
ios-switch[off] .ios-switch-dot, ios-switch[state="off"] .ios-switch-dot { left:2px; }
ios-segmented, ios-segmented { display:inline-flex; padding:2px; border-radius:9px; background:var(--rp-a-ios-fill-12); gap:2px; font-family:-apple-system,sans-serif; }
ios-segmented[block], ios-segmented[block] { display:flex; width:100%; }
ios-segmented[block] .rp-ios-seg-item { flex:1; text-align:center; }
.rp-ios-seg-item { padding:6px 16px; border-radius:7px; font-size:13px; font-weight:500; color:var(--rp-c-black); white-space:nowrap; }
.rp-ios-seg-item.active { background:var(--rp-surface); font-weight:600; box-shadow:0 3px 8px rgba(0,0,0,.12), 0 1px 1px rgba(0,0,0,.04); }
ios-button, ios-button { display:inline-grid; place-items:center; min-height:34px; padding:0 16px; border-radius:var(--rp-radius-md); background:var(--rp-c-ios-blue); color:var(--rp-c-white); font-size:15px; font-weight:600; font-family:-apple-system,sans-serif; }
ios-button[variant="tinted"], ios-button[variant="tinted"] { background:var(--rp-a-ios-blue-15); color:var(--rp-c-ios-blue); }
ios-button[variant="plain"], ios-button[variant="plain"] { background:transparent; color:var(--rp-c-ios-blue); }
ios-search, ios-search { display:flex; align-items:center; gap:6px; width:100%; max-width:100%; min-width:0; height:36px; padding:0 10px; border-radius:10px; background:var(--rp-a-ios-fill-12); color:var(--rp-c-ios-gray); font-size:16px; font-family:-apple-system,sans-serif; }
ios-search .rp-value { color:var(--rp-c-black); }
ios-stepper, ios-stepper { display:inline-flex; align-items:center; border-radius:var(--rp-radius-md); background:var(--rp-a-ios-fill-12); font-family:-apple-system,sans-serif; flex:0 0 auto; }
.rp-ios-step { display:grid; place-items:center; width:42px; height:32px; color:var(--rp-c-ios-blue); }
.rp-ios-step-value { min-width:28px; padding:0 4px; text-align:center; font-size:16px; font-weight:500; color:var(--rp-c-black); }
.rp-ios-step-div { width:1px; height:18px; background:var(--rp-a-black-15); }
`;

// iOS (Apple HIG) platform primitives. Static visual approximations only.

// Status bar (time + signal/wifi/battery glyphs), shown atop navbars.
function iosStatusBar(time = "9:41"): string {
  const signal =
    '<svg width="18" height="12" viewBox="0 0 18 12" fill="currentColor" aria-hidden="true"><rect x="0" y="8" width="3" height="4" rx="1"/><rect x="4.5" y="6" width="3" height="6" rx="1"/><rect x="9" y="3.5" width="3" height="8.5" rx="1"/><rect x="13.5" y="1" width="3" height="11" rx="1"/></svg>';
  const wifi =
    '<svg width="17" height="12" viewBox="0 0 17 12" fill="currentColor" aria-hidden="true"><path d="M8.5 2.2c2.6 0 5 1 6.8 2.7l-1.4 1.5A7.7 7.7 0 0 0 8.5 4.3 7.7 7.7 0 0 0 3.1 6.4L1.7 4.9A9.8 9.8 0 0 1 8.5 2.2Z"/><path d="M8.5 6c1.5 0 2.9.6 3.9 1.6l-1.5 1.5a3.4 3.4 0 0 0-4.8 0L4.6 7.6A5.5 5.5 0 0 1 8.5 6Z"/><circle cx="8.5" cy="10.3" r="1.4"/></svg>';
  const battery =
    '<svg width="27" height="13" viewBox="0 0 27 13" fill="none" aria-hidden="true"><rect x="0.5" y="0.5" width="22" height="12" rx="3.5" stroke="currentColor" stroke-opacity="0.35"/><rect x="2" y="2" width="17" height="9" rx="2" fill="currentColor"/><path d="M24.5 4.5c1 .3 1 3.7 0 4" stroke="currentColor" stroke-opacity="0.4" stroke-width="1.2" stroke-linecap="round"/></svg>';
  return `<div class="rp-ios-statusbar"><span>${escapeHtml(time)}</span><span class="rp-ios-statusbar-right">${signal}${wifi}${battery}</span></div>`;
}

export class IosNavbarElement extends HTMLElement {
  connectedCallback() {
    injectStyle();
    if (this.dataset.rpReady) return;
    this.dataset.rpReady = "true";
    const title = attr(this, "title", "标题");
    const large = this.hasAttribute("large");
    const back = attr(this, "back");
    const trailing = attr(this, "trailing");
    const trailingIcon = attr(this, "trailing-icon");
    const leadingIcon = attr(this, "leading-icon");
    const noStatusBar = this.hasAttribute("no-status-bar");
    const time = attr(this, "time", "9:41");
    // trailing: render CSV of icon names if trailing-icon set, else text
    const trailingHtml = trailingIcon
      ? csv(this, "trailing-icon", "")
          .map((n) => icon(n, 20))
          .join("")
      : trailing
        ? escapeHtml(trailing)
        : "";
    const leadingHtml = back
      ? `${icon("chevron-left", 20)}<span>${escapeHtml(back)}</span>`
      : leadingIcon
        ? icon(leadingIcon, 20)
        : "";
    this.innerHTML =
      (noStatusBar ? "" : iosStatusBar(time)) +
      `<div class="ios-navbar-row"><span class="rp-ios-nav-leading">${leadingHtml}</span><span class="rp-ios-nav-title">${large ? "" : escapeHtml(title)}</span><span class="rp-ios-nav-trailing">${trailingHtml}</span></div>` +
      (large ? `<div class="rp-ios-nav-large">${escapeHtml(title)}</div>` : "");
  }
}
export class IosTabbarElement extends HTMLElement {
  connectedCallback() {
    injectStyle();
    if (this.dataset.rpReady) return;
    this.dataset.rpReady = "true";
    const items = csv(this, "items", "首页,搜索,通知,我的");
    const icons = csv(this, "icons", "home,search,bell,user");
    const active = intAttr(this, "active", 0);
    this.innerHTML = items
      .map(
        (it, i) =>
          `<span class="rp-ios-tab${i === active ? " active" : ""}">${icon(icons[i] || "circle", 22)}<span class="rp-ios-tab-label">${escapeHtml(it)}</span></span>`,
      )
      .join("");
  }
}
export class IosListElement extends HTMLElement {
  connectedCallback() {
    injectStyle();
    if (this.dataset.rpReady) return;
    this.dataset.rpReady = "true";
    const header = attr(this, "header");
    const footer = attr(this, "footer");
    // Wrap the authored list-item children in a rounded white "card" so the
    // header/footer sit on the page background (modern inset-grouped style).
    const card = document.createElement("div");
    card.className = "rp-ios-list-card";
    while (this.firstChild) card.appendChild(this.firstChild);
    if (header) {
      const h = document.createElement("div");
      h.className = "ios-list-header";
      h.textContent = header;
      this.appendChild(h);
    }
    this.appendChild(card);
    if (footer) {
      const f = document.createElement("div");
      f.className = "ios-list-footer";
      f.textContent = footer;
      this.appendChild(f);
    }
  }
}
export class IosListItemElement extends HTMLElement {
  connectedCallback() {
    injectStyle();
    if (this.dataset.rpReady) return;
    this.dataset.rpReady = "true";
    const label = attr(this, "label", "项");
    const sub = attr(this, "sub") || attr(this, "subtitle");
    const detail = attr(this, "detail");
    const ic = attr(this, "icon");
    const chevron = this.hasAttribute("chevron");
    // Preserve any authored child elements (switch, avatar, tag, button) as
    // trailing slot content rather than discarding them.
    const slotted = Array.from(this.childNodes).filter(
      (n) =>
        n.nodeType === 1 ||
        (n.nodeType === 3 && (n.textContent || "").trim().length > 0),
    );
    const iconHtml = ic
      ? `<span class="rp-ios-li-icon">${icon(ic, 16)}</span>`
      : "";
    const bodyHtml = `<span class="rp-ios-li-body"><span class="rp-ios-li-label">${escapeHtml(label)}</span>${sub ? `<span class="rp-ios-li-sub">${escapeHtml(sub)}</span>` : ""}</span>`;
    const trailing = document.createElement("span");
    trailing.className = "rp-ios-li-trailing";
    if (detail) {
      const d = document.createElement("span");
      d.className = "rp-ios-li-detail";
      d.textContent = detail;
      trailing.appendChild(d);
    }
    slotted.forEach((n) => trailing.appendChild(n));
    if (chevron) {
      const c = document.createElement("span");
      c.className = "rp-ios-li-chevron";
      c.innerHTML = icon("chevron-right", 16);
      trailing.appendChild(c);
    }
    this.innerHTML = iconHtml + bodyHtml;
    this.appendChild(trailing);
  }
}
export class IosActionSheetElement extends HTMLElement {
  connectedCallback() {
    injectStyle();
    if (this.dataset.rpReady) return;
    this.dataset.rpReady = "true";
    const title = attr(this, "title");
    const actions = csv(this, "actions", "拍照,从相册选择,选择文件");
    const destructive = attr(this, "destructive");
    const group = `<div class="rp-ios-as-group">${title ? `<div class="rp-ios-as-title">${escapeHtml(title)}</div>` : ""}${actions.map((a) => `<div class="rp-ios-as-action${a === destructive ? " destructive" : ""}">${escapeHtml(a)}</div>`).join("")}</div>`;
    const cancel = `<div class="rp-ios-as-group"><div class="rp-ios-as-action cancel">取消</div></div>`;
    this.innerHTML = group + cancel;
  }
}
export class IosAlertElement extends HTMLElement {
  connectedCallback() {
    injectStyle();
    if (this.dataset.rpReady) return;
    this.dataset.rpReady = "true";
    const title = attr(this, "title", "提示");
    const message = attr(this, "message", "");
    const actions = csv(this, "actions", "取消,确定");
    this.innerHTML = `<div class="ios-alert-body"><div class="ios-alert-title">${escapeHtml(title)}</div>${message ? `<div class="ios-alert-msg">${escapeHtml(message)}</div>` : ""}</div><div class="ios-alert-actions">${actions.map((a, i) => `<span class="ios-alert-btn${i === actions.length - 1 ? " primary" : ""}">${escapeHtml(a)}</span>`).join("")}</div>`;
  }
}
export class IosSwitchElement extends HTMLElement {
  connectedCallback() {
    injectStyle();
    if (this.dataset.rpReady) return;
    this.dataset.rpReady = "true";
    const label = attr(this, "label");
    this.innerHTML = `${label ? `<span class="ios-switch-label">${escapeHtml(label)}</span>` : ""}<span class="ios-switch-track"><span class="ios-switch-dot"></span></span>`;
  }
}
export class IosSegmentedElement extends HTMLElement {
  connectedCallback() {
    injectStyle();
    if (this.dataset.rpReady) return;
    this.dataset.rpReady = "true";
    const options = csv(this, "options", "第一,第二,第三");
    const active = intAttr(this, "active", 0);
    this.innerHTML = options
      .map(
        (o, i) =>
          `<span class="rp-ios-seg-item${i === active ? " active" : ""}">${escapeHtml(o)}</span>`,
      )
      .join("");
  }
}
export class IosButtonElement extends HTMLElement {
  connectedCallback() {
    injectStyle();
    if (this.dataset.rpReady) return;
    this.dataset.rpReady = "true";
    this.innerHTML = `<span>${escapeHtml(attr(this, "label", this.textContent?.trim() || "按钮"))}</span>`;
  }
}
export class IosSearchElement extends HTMLElement {
  connectedCallback() {
    injectStyle();
    if (this.dataset.rpReady) return;
    this.dataset.rpReady = "true";
    const value = attr(this, "value");
    this.innerHTML = `${icon("search", 15)}<span class="${value ? "rp-value" : "rp-placeholder"}">${escapeHtml(value || attr(this, "placeholder", "搜索"))}</span>`;
  }
}
export class IosStepperElement extends HTMLElement {
  connectedCallback() {
    injectStyle();
    if (this.dataset.rpReady) return;
    this.dataset.rpReady = "true";
    const value = attr(this, "value");
    const mid = value
      ? `<span class="rp-ios-step-value">${escapeHtml(value)}</span>`
      : `<span class="rp-ios-step-div"></span>`;
    this.innerHTML = `<span class="rp-ios-step minus">${icon("minus", 16)}</span>${mid}<span class="rp-ios-step plus">${icon("plus", 16)}</span>`;
  }
}
